// Copyright (C) 2017-2023 Smart code 203358507

const Tooltip = require('./Tooltip');

module.exports = Tooltip;

